/* import __COLOCATED_TEMPLATE__ from './fin-phone-escalation-guidance.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type RouterService from '@ember/routing/router-service';
import type Guideline from 'embercom/models/ai-agent/guidelines';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Signature {
  Element: HTMLDivElement;
  Args: {};
}

export default class FinPhoneEscalationGuidance extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare router: RouterService;

  @tracked isLoading = true;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    this.loadGuidelines();
  }

  get guidelinesCountLabel() {
    return this.intl.t(
      'operator.fin.setup.tabs.setup-and-go-live.phone.fin-escalation-guidance.subtitle',
      {
        count: this.guidelinesCount.length,
      },
    );
  }

  get guidelinesCount(): Guideline[] {
    return this.store
      .peekAll('ai-agent/guidelines')
      .toArray()
      .filter((guideline) => guideline.enabled && guideline.category === 'voice_routing');
  }

  async loadGuidelines() {
    try {
      await this.store.findAll('ai-agent/guidelines');
    } catch (error) {
      console.error('Failed to load guidelines:', error);
    }

    this.isLoading = false;
  }

  @action
  navigateToGuidance() {
    let url = this.router.urlFor('apps.app.automation.fin-ai-agent.guidance', {
      queryParams: {
        tab: 'voice',
      },
    });
    safeWindowOpen(url, '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::FinPhoneEscalationGuidance': typeof FinPhoneEscalationGuidance;
  }
}
